import { Link } from 'react-router-dom';
import { animeList, featuredAnimeIds } from '@/mocks/anime';

export default function FeaturedSection() {
  const featured = animeList.filter((a) => featuredAnimeIds.includes(a.id));

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          <i className="ri-fire-line text-secondary-500 mr-2"></i>精选推荐
        </h2>
        <Link
          to="/category/recent"
          className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.slice(0, 8).map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
          >
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={anime.coverImage}
                alt={anime.title}
                title={`${anime.title} - 樱花动漫网高清在线观看`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
              />
              <div className="absolute top-2 right-2 px-2 py-1 bg-background-950/80 backdrop-blur-sm rounded-md">
                <span className="text-xs font-medium text-secondary-400">{anime.rating}</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-background-950/90 to-transparent">
                <span className="text-xs text-foreground-300">{anime.updateInfo}</span>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <div className="flex flex-wrap gap-1 mt-2">
                {anime.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 text-xs rounded-md bg-accent-100/10 text-accent-400 border border-accent-200/20"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}